import React from 'react';
import BentoCard from '../ui/BentoCard';
import MaterialIcon from '../ui/MaterialIcon';

function FlightOptionsGrid({
  departureDate,
  returnDate,
  cabin,
  adults,
  children,
  hideReturn,
  onDepartureDateChange,
  onReturnDateChange,
  onCabinChange,
  onAdultsChange,
  onChildrenChange,
}) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {/* Departure Date */}
      <BentoCard className="!p-4 !shadow-none border border-outline-variant/10">
        <div className="flex items-center gap-2 mb-2">
          <MaterialIcon name="calendar_today" size={18} className="text-primary" />
          <p className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label">Departure</p>
        </div>
        <input
          type="date"
          value={departureDate}
          onChange={(e) => onDepartureDateChange(e.target.value)}
          className="w-full text-sm font-semibold text-on-surface bg-transparent border-0 p-0 focus:outline-none focus:ring-0"
        />
      </BentoCard>

      {/* Return Date */}
      {!hideReturn && (
        <BentoCard className="!p-4 !shadow-none border border-outline-variant/10">
          <div className="flex items-center gap-2 mb-2">
            <MaterialIcon name="event" size={18} className="text-primary" />
            <p className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label">Return</p>
          </div>
          <input
            type="date"
            value={returnDate}
            onChange={(e) => onReturnDateChange(e.target.value)}
            className="w-full text-sm font-semibold text-on-surface bg-transparent border-0 p-0 focus:outline-none focus:ring-0"
          />
        </BentoCard>
      )}

      {/* Cabin Class */}
      <BentoCard className="!p-4 !shadow-none border border-outline-variant/10">
        <div className="flex items-center gap-2 mb-2">
          <MaterialIcon name="airline_seat_recline_extra" size={18} className="text-primary" />
          <p className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label">Cabin</p>
        </div>
        <select
          value={cabin}
          onChange={(e) => onCabinChange(e.target.value)}
          className="w-full text-sm font-semibold text-on-surface bg-transparent border-0 p-0 focus:outline-none focus:ring-0 appearance-none cursor-pointer"
        >
          <option value="Economy">Economy</option>
          <option value="Premium Economy">Premium Economy</option>
          <option value="Business">Business</option>
          <option value="First">First Class</option>
        </select>
      </BentoCard>

      {/* Passengers */}
      <BentoCard className="!p-4 !shadow-none border border-outline-variant/10">
        <div className="flex items-center gap-2 mb-2">
          <MaterialIcon name="group" size={18} className="text-primary" />
          <p className="text-[11px] font-semibold text-on-surface-variant/70 uppercase tracking-label">Passengers</p>
        </div>
        <div className="space-y-2">
          {/* Adults */}
          <div className="flex items-center justify-between">
            <span className="text-xs text-on-surface-variant">Adults</span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => onAdultsChange(Math.max(1, adults - 1))}
                className="w-7 h-7 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant hover:bg-primary-light hover:text-primary transition-colors text-xs font-bold"
                disabled={adults <= 1}
              >
                -
              </button>
              <span className="text-sm font-semibold text-on-surface w-4 text-center">{adults}</span>
              <button
                onClick={() => onAdultsChange(Math.min(9, adults + 1))}
                className="w-7 h-7 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant hover:bg-primary-light hover:text-primary transition-colors text-xs font-bold"
              >
                +
              </button>
            </div>
          </div>
          {/* Children */}
          <div className="flex items-center justify-between">
            <span className="text-xs text-on-surface-variant">Children</span>
            <div className="flex items-center gap-2">
              <button
                onClick={() => onChildrenChange(Math.max(0, children - 1))}
                className="w-7 h-7 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant hover:bg-primary-light hover:text-primary transition-colors text-xs font-bold"
                disabled={children <= 0}
              >
                -
              </button>
              <span className="text-sm font-semibold text-on-surface w-4 text-center">{children}</span>
              <button
                onClick={() => onChildrenChange(Math.min(9, children + 1))}
                className="w-7 h-7 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant hover:bg-primary-light hover:text-primary transition-colors text-xs font-bold"
              >
                +
              </button>
            </div>
          </div>
        </div>
      </BentoCard>
    </div>
  );
}

export default FlightOptionsGrid;
